var map = {
	"./ali.png": "a5c6",
	"./bank.png": "0b32",
	"./bank_old.png": "6baf",
	"./bank_old2.png": "5236",
	"./btc.png": "c7ea",
	"./commonpay.png": "7ecd",
	"./commonpay_old.png": "6257",
	"./jd.png": "1666",
	"./letter.png": "a5be",
	"./qq.png": "e6e1",
	"./usdt.png": "e0af",
	"./wx.png": "d030"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "867f";